import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=48556c26&scoped=true&"
import script from "./BannerSwiper.vue?vue&type=script&lang=js&"
export * from "./BannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=48556c26&lang=scss&scoped=true&"
import style1 from "./BannerSwiper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48556c26",
  null
  
)

export default component.exports